import React from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {accountsCountSelector} from 'features/accounts/selectors';
import {deleteAllAccounts} from 'features/accounts/reducers/recordsSlice';

import {ActionsControl} from './ActionsControl';

export const UserAccountsControl = () => {
    const dispatch = useDispatch();

    const accountsCount = useSelector((state) => accountsCountSelector(state));

    return (
        <ActionsControl
            label="Accounts"
            resourceCount={accountsCount}
            onClickHandler={() => dispatch(deleteAllAccounts())}
        />
    );
};
